export const PROFILE_LOAD_REQUESTING = "PROFILE_LOAD_REQUESTING";
export const PROFILE_LOAD_REQUESTED = "PROFILE_LOAD_REQUESTED";
export const PROFILE_LOAD_SUCCESS = "PROFILE_LOAD_SUCCESS";
export const PROFILE_LOAD_ERROR = "PROFILE_LOAD_ERROR";

export const PROFILE_UNLOAD_REQUESTING = "PROFILE_UNLOAD_REQUESTING";
export const PROFILE_UNLOAD_SUCCESS = "PROFILE_UNLOAD_SUCCESS";
export const PROFILE_UNLOAD_ERROR = "PROFILE_UNLOAD_ERROR";